import { Pack } from '../types/pack';
import { boolHttp, http } from './http';
import {
  GetPackUrl,
  PostOpenPackUrl,
  PostReleasePackUrl,
  GetCurrentPackUrl,
  PostValidatePackUrl,
  PutPackVersionLimitUrl,
  DeletePackUrl,
} from './urls';

const dateToLocal = (date: Date): Date => {
  const str = date.toString();
  return new Date(str.endsWith('Z') ? str : str + 'Z');
};

export interface ValidationResult {
  success: boolean;
}

const PackSettingsService = {
  getAll: async (lang: string): Promise<Pack[]> => {
    const req = new Request(GetPackUrl(lang), { method: 'GET' });
    return (await http<Pack[]>(req)).map((item) => {
      return {
        ...item,
        lastDownloadDate: dateToLocal(item.lastDownloadDate),
        createdAt: dateToLocal(item.createdAt),
        updatedAt: dateToLocal(item.updatedAt),
      };
    });
  },

  getCurrent: async (lang: string): Promise<Pack> => {
    const req = new Request(GetCurrentPackUrl(lang), { method: 'GET' });
    return await http<Pack>(req);
  },

  open: async (lang: string): Promise<boolean> => {
    const req = new Request(PostOpenPackUrl(lang), { method: 'POST' });
    return await boolHttp(req);
  },

  release: async (lang: string): Promise<boolean> => {
    const req = new Request(PostReleasePackUrl(lang), { method: 'POST' });
    return await boolHttp(req);
  },

  validate: async (lang: string, version: number): Promise<ValidationResult> => {
    const req = new Request(PostValidatePackUrl(lang, version), {
      method: 'POST',
    });
    return await http<ValidationResult>(req);
  },

  updateVersionLimit: async (
    lang: string,
    version: number,
    versionLimit: string | null
  ): Promise<Pack | null> => {
    const req = new Request(PutPackVersionLimitUrl(), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lang, version, versionLimit }),
    });
    const result = await http<Pack>(req);
    if (!result) return null;
    return {
      ...result,
      lastDownloadDate: dateToLocal(result.lastDownloadDate),
      createdAt: dateToLocal(result.createdAt),
      updatedAt: dateToLocal(result.updatedAt),
    };
  },

  delete: async (id: number): Promise<boolean> => {
    const req = new Request(DeletePackUrl(id), { method: 'DELETE' });
    return await boolHttp(req);
  },
};

export default PackSettingsService;
